var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22C12.866 22 16 18.866 16 15C16 11.134 12.866 8 9 8C5.13401 8 2 11.134 2 15C2 16.2436 2.32427 17.4114 2.89287 18.4235L2.0411 20.9788C1.83919 21.5845 2.41546 22.1608 3.02118 21.9589L5.57649 21.1071C6.58863 21.6757 7.75644 22 9 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.23126C22 2.99897 20.9926 2 19.75 2H9.25C8.00736 2 7 2.99897 7 4.23126V6.73663C7.64138 6.58195 8.31112 6.5 9 6.5C13.0613 6.5 16.4573 9.34831 17.2995 13.1563H19L20.6643 15.2194C21.1072 15.7684 22 15.4578 22 14.7548V4.23126Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsAlt1);
export default __webpack_public_path__ + "static/media/comments-alt-1.0a90c7c9ff4d2e5c8b4925418ee001c3.svg";
export { ForwardRef as ReactComponent };